import Vue from 'vue'
import { AlisEditorPc, AlisEditorSp } from '@alisproject/alis-editor'

Vue.component('alis-editor-pc', AlisEditorPc)
Vue.component('alis-editor-sp', AlisEditorSp)
